import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { graphApi } from '../services/msGraph';
import { studentPortalApi } from '../services/generated/studentPortalApi';
import { timetableReducer } from '@versita/frontend/timetable-state';
import timeTableManagerReducer from '../state/slices/timetableManagerSlice';
import environment from '../environments/environment';
import * as Sentry from '@sentry/react';

const middleware = [graphApi.middleware, studentPortalApi.middleware];

if (!environment.production) {
  middleware.push(
    createLogger({
      predicate: (_, { type }) => !type.includes('Api'),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any,
  );
}

export const store = configureStore({
  reducer: {
    timetable: timetableReducer,
    timetableManager: timeTableManagerReducer,
    [graphApi.reducerPath]: graphApi.reducer,
    [studentPortalApi.reducerPath]: studentPortalApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: (defaultEnhancers) => [
    ...defaultEnhancers,
    Sentry.createReduxEnhancer({}),
  ],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
